import { RoutePaths } from '../../constants';

/** Для страниц с тёмным фоном */
export const LIGHT_THEME_COLOR = 'rgba(255, 255, 255, 0.9)';

/** Для страниц со светлым фоном */
export const DARK_THEME_COLOR = 'rgba(0, 0, 0, 0.9)';

/** Роуты, для которых применяется светлая тема (белый цвет элементов) */
export const LIGHT_THEME_ROUTES = [RoutePaths.Main, `${RoutePaths.Category}/`, RoutePaths.Prompt] as const;

export const isLightThemeRoute = (pathname: string) => {
    return LIGHT_THEME_ROUTES.some(route => {
        if (route === RoutePaths.Main) {
            return pathname === route;
        }

        return pathname.startsWith(route);
    });
};
